import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, PRODUCT, TICKER_ITEMS } from '../data/woodworking';
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const half = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden bg-bottle" data-id="element-127" data-mp="1vz47j6092way">
        <p className="sr-only" data-id="element-128" data-mp="29xbx2suyivc3">{TICKER_ITEMS.join(' • ')}</p>
        <div className="animate-marquee flex h-[26px] w-max items-center sm:h-[30px]" aria-hidden data-id="element-129" data-mp="25v75s0rzeasm">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap text-[11px] font-semibold leading-none uppercase tracking-[0.16em] text-ivory" data-id="element-130" data-mp="3la4n9z83nbq1" data-mpi={index}>
              {item}
              <span className="mx-7 h-1 w-1 rounded-full bg-brass-light sm:mx-9" data-id="element-131" data-mp="1bvqybeij3aho" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-pine/10 bg-linen/95 backdrop-blur' : 'border-transparent bg-linen'}`} data-id="element-132" data-mp="1kwxji0w4h9h9">
        <div className="mx-auto flex h-[60px] w-full max-w-6xl items-center justify-between gap-4 px-5 sm:h-14 sm:px-8" data-id="element-133" data-mp="1ptxmg2xodw45">
          <a href="#top" className="flex min-h-[44px] min-w-0 items-center" aria-label={`${PRODUCT.name} — back to top`} data-id="element-134" data-mp="x737tmnjhqyl">
            <span className="wordmark text-left text-[clamp(0.9rem,4.2vw,1.1rem)] leading-tight text-pine sm:text-[1rem]" data-id="element-135" data-mp="1267di3b996k6">
              Woodworking Projects That Sell<sup className="ml-0.5 font-sans text-[0.55em] font-semibold" data-id="element-136" data-mp="16z0k6wqaaoyw">™</sup>
            </span>
          </a>
          <nav aria-label="Sections" className="hidden items-center gap-5 lg:flex xl:gap-7" data-id="element-137" data-mp="egv71b7bbclk">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[0.88rem] font-medium text-moss hover:text-bottle" data-id="element-138" data-mp="1hqqwqbyhh9lc">
                {link.label}
              </a>)}
          </nav>
          <a href={OFFER_ANCHOR} className="hidden min-h-[44px] items-center whitespace-nowrap rounded-[8px] bg-ember px-4 text-[0.8rem] font-bold uppercase tracking-[0.06em] text-white hover:bg-ember-deep sm:inline-flex" data-id="element-139" data-mp="1qiswe80qaluk">
            Get the Plans
          </a>
        </div>
      </header>
    </>;
}